var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcMastercard = function SvgIcMastercard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z",
    stroke: "#1F242F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7075 22.4392C21.1423 23.7699 19.1121 24.5732 16.8936 24.5732C11.9435 24.5732 7.93066 20.5736 7.93066 15.6399C7.93066 10.7061 11.9435 6.70654 16.8936 6.70654C19.1121 6.70654 21.1423 7.50987 22.7075 8.8406C24.2726 7.50987 26.3028 6.70654 28.5213 6.70654C33.4714 6.70654 37.4843 10.7061 37.4843 15.6399C37.4843 20.5736 33.4714 24.5732 28.5213 24.5732C26.3028 24.5732 24.2726 23.7699 22.7075 22.4392Z",
    fill: "#ED0006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.707 22.4392C24.6342 20.8006 25.8562 18.3625 25.8562 15.6399C25.8562 12.9173 24.6342 10.4791 22.707 8.8406C24.2722 7.50987 26.3024 6.70654 28.5209 6.70654C33.471 6.70654 37.4838 10.7061 37.4838 15.6399C37.4838 20.5736 33.471 24.5732 28.5209 24.5732C26.3024 24.5732 24.2722 23.7699 22.707 22.4392Z",
    fill: "#F9A000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7077 22.4393C24.6349 20.8008 25.8568 18.3627 25.8568 15.6401C25.8568 12.9175 24.6349 10.4794 22.7077 8.84082C20.7806 10.4794 19.5586 12.9175 19.5586 15.6401C19.5586 18.3627 20.7806 20.8008 22.7077 22.4393Z",
    fill: "#FF5E00"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcMastercard);
export default ForwardRef;